import type { EvidenceItem } from "@/mocks/types";

const statusMeta: Record<
  EvidenceItem["status"],
  { label: string; tone: string; icon: string }
> = {
  verified: {
    label: "已核验",
    tone: "bg-secondary-100 text-secondary-800 border-secondary-200",
    icon: "ri-checkbox-circle-line",
  },
  pending: {
    label: "待核验",
    tone: "bg-accent-100 text-accent-900 border-accent-200",
    icon: "ri-time-line",
  },
  refuted: {
    label: "已证伪",
    tone: "bg-primary-100 text-primary-800 border-primary-200",
    icon: "ri-close-circle-line",
  },
};

interface EvidenceListProps {
  items: EvidenceItem[];
}

export default function EvidenceList({ items }: EvidenceListProps) {
  return (
    <ul className="space-y-3">
      {items.map((item, index) => {
        const meta = statusMeta[item.status];
        return (
          <li
            key={`${item.title}-${index}`}
            className="flex flex-col gap-3 rounded-lg border border-background-200 bg-background-50 p-4 sm:flex-row sm:items-start md:p-5"
          >
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-background-100 font-label text-sm font-bold text-foreground-600">
              {String(index + 1).padStart(2, "0")}
            </span>
            <div className="min-w-0 flex-1">
              <div className="flex flex-wrap items-center gap-2">
                <span className="rounded-md border border-background-300 bg-background-100 px-2 py-0.5 font-label text-[11px] text-foreground-600">
                  {item.kind}
                </span>
                <span className={`inline-flex items-center gap-1 rounded-md border px-2 py-0.5 font-label text-[11px] ${meta.tone}`}>
                  <i className={`${meta.icon} text-[13px]`} aria-hidden="true"></i>
                  {meta.label}
                </span>
              </div>
              <h4 className="mt-2 font-heading text-[15px] font-bold text-foreground-950">{item.title}</h4>
              <p className="mt-1.5 text-[13px] leading-relaxed text-foreground-600">{item.note}</p>
            </div>
          </li>
        );
      })}
    </ul>
  );
}